document.addEventListener('DOMContentLoaded', function() {
  //reset captcha
  $('form')
    .find('[name$="[captcha]"]')
    .each(function() {
      $(this).val('');
    });

  $('form').on('click', '.captcha__reload', function() {
    $(this)
      .parents('.captcha-field')
      .find('[name$="[captcha]"]')
      .val('');
  });
});
